export default __webpack_public_path__ + "static/media/paid-channel-img.8d63eed8.png";